import { render, staticRenderFns } from "./workflow-task-alert-list.vue?vue&type=template&id=25ff61b1&scoped=true"
import script from "./workflow-task-alert-list.vue?vue&type=script&lang=js"
export * from "./workflow-task-alert-list.vue?vue&type=script&lang=js"
import style0 from "./workflow-task-alert-list.vue?vue&type=style&index=0&id=25ff61b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff61b1",
  null
  
)

export default component.exports